<template>
  <div>
    <b-row>
      <b-col md="6">
        <b-form-group label="Operador Solicitante">
          <input-select v-model="model.codigoOperadorSolicitante" :options="operadores" single />
        </b-form-group>
      </b-col>

      <b-col md="3">
        <b-form-group label="Contexto">
          <input-select
            v-model="model.contexto"
            :options="$api.Arrays.ContextoAnalise"
            placeholder="Todos"
            single
            :input="refresh"
          />
        </b-form-group>
      </b-col>

      <b-col md="3">
        <b-form-group label="Solicitações para Análise">
          <input-select
            v-model="model.solicitacoesAnalise"
            :options="$api.Arrays.SolicitacoesAnaliseOptions"
          />
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col md="3">
        <b-form-group label="Situação">
          <input-select
            v-model="model.situacao"
            :options="$api.Arrays.SituacaoAnaliseCadastral"
          />
        </b-form-group>
      </b-col>

      <b-col md="3">
        <b-form-group label="Data Inicial">
          <input-date
            required
            v-model="model.dtInicial"
            :max="model.dtFinal"
            @change="validarDatas"
            @input="validarDatas"
          />
        </b-form-group>
      </b-col>

      <b-col md="3">
        <b-form-group label="Data Final">
          <input-date
            required
            v-model="model.dtFinal"
            :min="model.dtInicial"
            :max="new Date()"
            @change="validarDatas"
            @input="validarDatas"
          />
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  props: {
    value: Object
  },
  data() {
    return {
      operadores: [],
    }
  },
  computed: {
    model: {
      get() {
        return this.value || {}
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    refresh() {
      this.$emit('refresh')
    },
    getAllOperadores() {
      let th = this
      th.$api.Operadores.Combo().then(function (data) {
        if (Array.isArray(data)) {
          data.forEach(function (item) {
            let operador = {
              value: item.guid,
              text: item.string
            }
            th.operadores.push(operador)
          })
        }
      })
    },
    validarDatas() {
      const { dtInicial, dtFinal } = this.model

      if (!dtInicial || !dtFinal) {
        this.$api.UI.ShowError('Validação', 'Ambas as datas são obrigatórias.')
        return false
      }

      const dataInicial = new Date(dtInicial)
      const dataFinal = new Date(dtFinal)

      if (dataFinal < dataInicial) {
        this.$api.UI.ShowError('Validação', 'A Data Final não pode ser menor que a Data Inicial.')
        this.$nextTick(function () {
            this.model.dtFinal = null
        })
        return false
      }

      const diffDias = Math.ceil((dataFinal - dataInicial) / (1000 * 60 * 60 * 24))
      if (diffDias > 180) {
        this.$api.UI.ShowError('Validação', 'O intervalo entre as datas não pode ser superior a 180 dias.')
        this.$nextTick(function () {
            this.model.dtFinal = null
        })
        
        return false
      }

      return true
    }
  },
  mounted() {
    const hoje = new Date()
    this.model = {
      contexto: null,
      solicitacoesAnalise: { value: 1, text: 'Permitidas' },
      situacao: this.$api.Arrays.SituacaoAnaliseCadastral.find(x => x.text === 'Pendente'),
      dtInicial: hoje,
      dtFinal: hoje,
      operador: null
    }
  },
  beforeMount() {
    this.getAllOperadores()
  }
}
</script>
